/* eslint-disable no-console */
import { Features } from 'common/constants/features';

import { isFeatureEnabled } from './isFeatureEnabled';
import { VISUAL_REFRESH } from './visualRefresh';

import type { FeatureKey } from '../types';

export const logEnabledFeatures = () => {
  console.log('*** Enabled features:');
  Object.entries(Features).forEach(([key]) => {
    console.log(`*** ${key}: ${isFeatureEnabled(key as FeatureKey)}`);
  });

  // Logged separately because the refresh is not an environment flag: it defaults to on, and a
  // per-user `?visualRefresh=` override can turn it off — which is exactly what you need to see
  // when someone reports the app "looking wrong".
  console.log(`*** VisualRefresh (resolved, incl. ?visualRefresh= override): ${VISUAL_REFRESH}`);

  const version = window._env_.VITE_APP_TAG;
  const commit = window._env_.VITE_APP_COMMIT;
  console.log('*** Natter version:', version, commit ? `(${commit}) ***` : '***');
};
